import { UserConnections } from 'common/types/userConnections.types'
import { get, post, put } from 'hooks/use-http/useHttp'
import { Connection, Incoming } from 'common/types/connection.types'

export const fetchAllConnections = async (id: string, page: number = 1, filter = null) => {
  const response: UserConnections = await get(
    `connections/${id}?page=${page}&pageSize=20&dir=desc&sort=updated_at&statusFilter=${filter}`,
    {
      dieSilent: true
    }
  )

  return response
}

export const fetchIncomingConnections = async (id: string, page: number = 1, filter = null) => {
  const response: Incoming = await get(
    `/connections/${id}/requests?page=${page}&pageSize=20&dir=desc&sort=updated_at&statusFilter=${filter}`,
    {
      dieSilent: true
    }
  )
  return response
}

export const sendConnectionRequest = async (connectUserId: string, loggedInUserId: string) => {
  const response: Connection = await post(
    `connections/${loggedInUserId}/request/connectId/${connectUserId}/connect`,
    { dieSilent: true }
  )
  return response
}

export const removeConnection = async (userId: string, connectId: string, connectionId: string) => {
  const response: any = await put(
    `connections/${userId}/request/connectId/${connectId}/connection/${connectionId}/action/remove`,
    {
      dieSilent: true
    }
  )
  return response
}

export const fetchConnectionById = async (userId: string, connectId: string) => {
  const response: Connection = await get(`connections/${userId}/connectId/${connectId}`, {
    dieSilent: true
  })

  return response
}

export const blockConnection = async (userId: string, connectId: string, connectionId: string) => {
  const response: any = await put(
    `connections/${userId}/request/connectId/${connectId}/connection/${connectionId}/action/block`,
    {
      dieSilent: true
    }
  )
  return response
}

export const cancelConnectionById = async (connectUserId: string, loggedInUserId: string, canceledConnectionId: string) => {
  const response: Connection = await put(
    `connections/${loggedInUserId}/request/connectId/${connectUserId}/connection/${canceledConnectionId}/action/cancel`,
    {},
    { dieSilent: true }
  )
  return response
}

export const acceptConnection = async (connectUserId: string, loggedInUserId: string, acceptedConnectionId: string) => {
  const response: Connection = await put(
    `connections/${loggedInUserId}/request/connectId/${connectUserId}/connection/${acceptedConnectionId}/action/accept`,
    {},
    { dieSilent: true }
  )
  return response
}

export const declineConnection = async (userId: string, connectId: string, connectionId: string) => {
  const response: any = await put(
    `connections/${userId}/request/connectId/${connectId}/connection/${connectionId}/action/reject`,
    {
      dieSilent: true
    }
  )
  return response
}

const fetchSuggestedConnections = async (userId: string, page: number = 1, pageSize: number = 5) => {
  const response: any = await get(
    `connections/${userId}/suggested/connections?page=${page}&pageSize=${pageSize}&dir=desc&sort=updated_at`,
    { dieSilent: true }
  )
  return response
}

const fetchConnectionCounts = async (userId: string) => {
  const response: Number = await get(`connections/${userId}/counts`, { dieSilent: true })
  return response
}

const createInstantConnection = async (connectUserId: string, loggedInUserId: string) => {
  const response: Connection = await post(
    `connections/${loggedInUserId}/request/connectId/${connectUserId}/connect/instant`,
    {},
    { useApiKey: true, dieSilent: true }
  )
  return response
}

export const useConnectionApi = () => {
  return {
    fetchAllConnections,
    blockConnection,
    sendConnectionRequest,
    fetchConnectionById,
    removeConnection,
    cancelConnectionById,
    fetchIncomingConnections,
    acceptConnection,
    declineConnection,
    fetchSuggestedConnections,
    fetchConnectionCounts,
    createInstantConnection
  } as const
}
